
import _has from 'lodash-es/has';
import _set from 'lodash-es/set';

import { IApiPagingInput } from "libraries/service/resources/IApiPagingInput";
import { IProcessingSearchParameters } from "./IProcessingSearchParameters";
import { IProcessingRQ } from "libraries/service/resources/model/search/IProcessing";

export class ApiProcessingSearchParameters {
    public recordset: IApiPagingInput = {
        first: 1,
        nbrecord: 20,
    };

    public processing: IProcessingRQ;

    public orderBy : IOrderBy;

    public static fromSearchParameters(input: IProcessingSearchParameters) {
        const result = new ApiProcessingSearchParameters();
        const inputFirst = input && input.first || 1;
        //
        result.recordset.nbrecord = input && input.nbrecord || 20;
        result.recordset.first = Math.max(1, inputFirst);
        result.processing = {};

        if(input && input.status){
            result.processing.status = input.status;
        }
        if(input && input.type){
            result.processing.type = input.type;
        }
        if(_has(input, ['whenCreated', 'min'])){
                _set(result, ['processing', 'whenCreated', 'min'], input.whenCreated.min);
        }
        if(_has(input, ['whenCreated', 'max'])){
                _set(result, ['processing', 'whenCreated', 'max'], input.whenCreated.max);
        }

        return result;
    }
}

export interface IOrderBy {
    field : string;
    order : string;
}
